import React from 'react'
import styles from './styles.module.css'

function Head(props) {
  return (
    <div className={styles.zhyl_ckd_head}>
      <span className={styles.zhyl_ckd_head_title}>CKD可计算表型工具</span>
      <span className={styles.zhyl_ckd_head_text}>
        从真实世界医疗数据中快速抓取信息来识别慢性肾脏病的工具
      </span>
    </div>
  )
}

export default Head
